(ns dre.components.breadcrumb
  (:require
   ["antd" :refer [Breadcrumb]]
   [dre.app.router :as router]
   [dre.i18n.utils :as i18n]
   [dre.components.icons-iconoir :refer [icoinor-icon]]
   [dre.pages.frontpage.events :as frontpage]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def page->title
  {:not-found (i18n/tr-later "Not found")
   :frontpage "Literature Search"
   :search (i18n/tr-later "Results")
   :detail (i18n/tr-later "Detail")
   :my-searches (i18n/tr-later "Saved")
   :signals (i18n/tr-later "Saved Searches")
   :search-history (i18n/tr-later "Search History")
   :tags (i18n/tr-later "Tags")
   :shared (i18n/tr-later "Shared")
   :annotator (i18n/tr-later "Annotator")
   :dictionary (i18n/tr-later "Dictionary")
   :videos (i18n/tr-later "Videos")
   :admin (i18n/tr-later "Admin")
   :admin-help (i18n/tr-later "Admin - Help Settings")
   :admin-feed (i18n/tr-later "Admin - Feed Settings")
   :admin-survey (i18n/tr-later "Admin - Surveys")
   :admin-usage (i18n/tr-later "Admin - Usage Reports")
   :admin-client-download (i18n/tr-later "Admin - Client Downloads")
   :ai-summarization-usage (i18n/tr-later "Admin - AI Summarization Usage")})

(rf/reg-sub
 ::items
 (fn [db _]
   [{:title (page->title :frontpage)
     :href (router/->route :frontpage)
     :onClick #(rf/dispatch [::frontpage/clear-state])}
    {:title (-> db :pages :current page->title)}]))

(rf/reg-sub
 ::items-results
 (fn [db [_ viewtype viewtype-props question]]
   (remove nil? [{:title (page->title :frontpage)
                  :href (router/->route :frontpage)
                  :onClick #(rf/dispatch [::frontpage/clear-state])}
                 (when (and viewtype viewtype-props) {:title (r/as-element (:title viewtype-props))
                                                      :href (router/->route :frontpage)
                                                      :onClick #(rf/dispatch [::frontpage/set-topic-search-with-selection viewtype])})
                 {:title (if question
                           (str (-> db :pages :current page->title) ": " question)
                           (-> db :pages :current page->title))}])))

(defn breadcrumb
  ([] [breadcrumb @(rf/subscribe [::items])])
  ([items]
   [:> Breadcrumb
    {:separator (r/as-element [icoinor-icon :nav-arrow-right {:width "1em" :height "1em"}])
     :items items}]))
